// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pointsDisplay{display:flex;gap:2px;font-weight:var(--weight-light);line-height:16px;color:#fff}.pointsDisplay--styledNumber{border-radius:15px;background-color:#3567ff;background-color:var(--colors-accent-accent-100, #3567ff);padding-block:0;padding-inline:10px;height:18px;align-items:center;justify-content:center}.pointsDisplay__points{font-size:12px}.pointsDisplay__currency{font-size:8px}", ""]);
// Exports
module.exports = exports;
